import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import InvestingEntityType from 'src/app/dashboard/models/InvestingEntityType.enum';

@Component({
  selector: 'terra-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // standalone
})
export class InvestorComponent{
  InvestingEntityType = InvestingEntityType;
  @Input() full: boolean = false;
  @Input() investor: {
    id: string;
    name: string;
    email: string;
    type: InvestingEntityType;
  };

}
